// User Model
import { Model } from '@vuex-orm/core';

export default class CourseV2 extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'courses';

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            image: this.attr(''),
            description: this.attr(''),
            available: this.attr(false),
            available_through_module_guards: this.attr(false),
            count: this.attr(0),
            salespage: this.attr(''),
            slug: this.attr(''),
            color_theme: this.attr(''),
            module_theme: this.attr(''),
            theme: this.attr(''),
            attachments_count: this.attr(0),
            first_lesson_url: this.attr(''),
            module_count: this.attr(0),
            lesson_count: this.attr(0),
            progress: this.attr(0),
            trophy: this.attr(null),
            attachments: this.attr(null),
            highlighted: this.attr(false),
            numbered: this.attr(false),
            last_activity: this.attr(''),
            manual_finish: this.attr(false),
            hidden: this.attr(false),
            only_show_modules_available_by_guards: this.attr(false),
            modules: this.attr([]),
            author: this.attr(false),
            index: this.attr(0),
            scripts: this.attr([]),
            overview_visible: this.attr(false),
            visible_when_available: this.attr(false),
            details_visible: this.attr(false),
            release_date: this.attr(null),
            course_fully_loaded: this.attr(false),
            certificate: this.attr(null),
            certificate_send_option: this.attr(null),
            visibility: this.attr(null),
            availability: this.attr(null),
        };
    }

    get is_released() {
        if (this.release_date === null) {
            return false;
        }

        return Date.now() >= new Date(this.release_date);
    }

    get is_draft() {
        return this.release_date === null;
    }

    get is_planned() {
        return !this.is_released && !this.is_draft;
    }

    static apiConfig = {
        actions: {
            fetch(params) {
                // return a promise with the result so we can use the pagination data
                return new Promise((resolve) => {
                    this.get('/api/v3/courses', {
                        params,
                        dataTransformer: (response) => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    });
                });
            },

            fetchBySlug(slug) {
                const params = new URLSearchParams();

                params.append('find_by', 'slug');
                params.append('with', 'uploads,author,trophy');

                return new Promise((resolve) => {
                    this.get(`/api/v3/courses/${slug}`, {
                        params,
                        dataTransformer: (response) => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    });
                });
            },

            fetchCoursesByAuthorId(author_id) {
                return new Promise((resolve) => {
                    this.get('/api/v3/courses?where=author_id:' + author_id, {
                        dataTransformer: (response) => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    });
                });
            },

            fetchHighlighted() {
                return new Promise((resolve) => {
                    this.get('/api/v3/courses?where=highlighted:1', {
                        save: false,
                        dataTransformer: (response) => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    });
                });
            },
        },
    };
}

window.CourseV2 = CourseV2;
